import React from 'react';
import { OdinController } from '@myosh/odin-components';
import DependentPersonField from './dependent-person-field.component';
import type { PersonFieldProps } from './person-field.component';
import type { PersonFieldDependentProps } from '../../../@types/forms';

interface HfPersonFieldProps extends PersonFieldProps, PersonFieldDependentProps {
  name: string;
}

export default function HfPersonField(props: HfPersonFieldProps) {
  const { name, control, value, onChange, ...rest } = props;
  return (
    <OdinController
      name={name as string}
      control={control}
      defaultValue={value}
      onChange={onChange}
      render={({ field: { ref: fieldRef, onChange, value }, fieldState: { error } }) => (
        <DependentPersonField
          {...rest}
          control={control}
          value={value}
          onChange={onChange}
          error={error?.message}
          inputRef={fieldRef}
        />
      )}
    />
  );
}
